module.exports = __webpack_public_path__ + "static/media/videoBadgeLevel2Locked.2d6aebf3.png";